import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-6 text-brand-charcoal/80 leading-relaxed" data-id="element-77">
    <h2 className="text-3xl font-heading text-brand-teal mb-6" data-id="element-78">
      Política de Privacidad
    </h2>
    <p data-id="element-79">
      <strong data-id="element-80">Última actualización:</strong> Abril 2026
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-81">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-82">
      Recopilamos únicamente la información necesaria para procesar tu compra y
      entregarte el producto digital, incluyendo tu nombre, dirección de correo
      electrónico y datos de pago procesados de forma segura por nuestro
      proveedor de pagos.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-83">
      2. Uso de la Información
    </h3>
    <p data-id="element-84">Tu información personal se utiliza exclusivamente para:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-85">
      <li data-id="element-86">Procesar y entregar tu compra.</li>
      <li data-id="element-87">Enviarte actualizaciones relacionadas con el producto adquirido.</li>
      <li data-id="element-88">Responder a consultas de soporte.</li>
    </ul>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-89">
      3. Protección de Datos
    </h3>
    <p data-id="element-90">
      Implementamos medidas de seguridad estándar de la industria para proteger
      tu información personal. No vendemos, intercambiamos ni transferimos tu
      información personal a terceros sin tu consentimiento.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-91">4. Cookies</h3>
    <p data-id="element-92">
      Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
      navegación. Puedes configurar tu navegador para rechazar cookies, aunque
      esto podría afectar algunas funcionalidades.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-93">5. Tus Derechos</h3>
    <p data-id="element-94">
      Tienes derecho a acceder, rectificar o eliminar tu información personal en
      cualquier momento. Para ejercer estos derechos, puedes comunicarte con
      nosotros a través de los canales disponibles.
    </p>
  </div>;
const termsContent = <div className="space-y-6 text-brand-charcoal/80 leading-relaxed" data-id="element-95">
    <h2 className="text-3xl font-heading text-brand-teal mb-6" data-id="element-96">
      Términos y Condiciones
    </h2>
    <p data-id="element-97">
      <strong data-id="element-98">Última actualización:</strong> Abril 2026
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-99">
      1. Producto Digital
    </h3>
    <p data-id="element-100">
      El Protocolo de "Desconexión Segura" es un producto digital en formato
      PDF. Al completar tu compra, recibirás acceso inmediato al material. Este
      producto es para uso personal y no puede ser redistribuido, revendido ni
      compartido.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-101">
      2. Uso del Contenido
    </h3>
    <p data-id="element-102">
      Todo el contenido del protocolo está protegido por derechos de autor.
      Queda prohibida su reproducción, distribución o modificación sin
      autorización expresa por escrito.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-103">
      3. Descargo de Responsabilidad
    </h3>
    <p data-id="element-104">
      Este producto tiene fines educativos e informativos. No sustituye el
      consejo profesional de un psicólogo, terapeuta o profesional de salud
      mental. Si estás en una situación de crisis, te recomendamos buscar ayuda
      profesional inmediata.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-105">
      4. Política de Reembolso
    </h3>
    <p data-id="element-106">
      Debido a la naturaleza digital del producto y su entrega inmediata, no se
      ofrecen reembolsos una vez completada la descarga. Si tienes problemas
      técnicos para acceder al material, nos comprometemos a resolverlos.
    </p>

    <h3 className="text-xl font-bold text-brand-teal mt-8" data-id="element-107">
      5. Modificaciones
    </h3>
    <p data-id="element-108">
      Nos reservamos el derecho de actualizar estos términos en cualquier
      momento. Los cambios serán efectivos desde su publicación en esta página.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-charcoal py-10 text-center" data-id="element-109">
        <p className="text-white/40 text-sm mb-4" data-id="element-110">
          © {new Date().getFullYear()} El Protocolo de Desconexión Segura.
          Todos los derechos reservados.
        </p>
        <div className="flex items-center justify-center gap-6" data-id="element-111">
          <button onClick={() => setActiveModal('privacy')} className="text-white/50 hover:text-brand-gold text-sm transition-colors duration-200" data-id="element-112">
            Política de Privacidad
          </button>
          <span className="text-white/20" data-id="element-113">|</span>
          <button onClick={() => setActiveModal('terms')} className="text-white/50 hover:text-brand-gold text-sm transition-colors duration-200" data-id="element-114">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <AnimatePresence data-id="element-115">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-116">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 md:p-10 relative" onClick={e => e.stopPropagation()} data-id="element-117">
              <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center hover:bg-brand-teal/10 transition-colors" data-id="element-118">
                <XIcon className="w-5 h-5 text-brand-charcoal" data-id="element-119" />
              </button>
              {activeModal === 'privacy' ? privacyContent : termsContent}
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}